import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=6ecd3b4c&scoped=true&"
import script from "./preview.vue?vue&type=script&lang=js&"
export * from "./preview.vue?vue&type=script&lang=js&"
import style0 from "./preview.vue?vue&type=style&index=0&id=6ecd3b4c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecd3b4c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Bottom: require('/app/components/bottom.vue').default})
